export const ASC_SORT_DIRECTION = 'asc';
export const DESC_SORT_DIRECTION = 'desc';

const sortDirectionList = [ASC_SORT_DIRECTION, DESC_SORT_DIRECTION] as const;

export type SortDirection = (typeof sortDirectionList)[number];
